module.exports = __webpack_public_path__ + "img/waterfalls-pool--icon--gray.76caa6db.svg";